import { ERentioFormField } from "../../components/components/Form";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.createPayment.types";
import { customContactsSelector, customContactsValueSelector, getDefaultPayerPayeeValue, getNavigationTitle, getRelatedContract, getSubtitle, } from "./schema.createPayment.utils";
import { customGetContactsActions, customIsFetchingSelector, } from "./schema.createPayment.utils.fetchContacts";
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a;
        var _b;
        var contract = getRelatedContract(extraData, defaultValues);
        return {
            required: [EField.Payee],
            properties: (_a = {},
                _a[EField.Header5] = {
                    default: undefined,
                },
                _a[EField.Payee] = {
                    default: getDefaultPayerPayeeValue({
                        key: EField.Payee,
                        initialValues: initialValues,
                        defaultValues: defaultValues,
                        type: defaultValues[EField.TypeRecurring] ||
                            defaultValues[EField.TypeOnce],
                        contract: contract,
                        costPayment: !!((_b = extraData.prefill) === null || _b === void 0 ? void 0 : _b.costPayment),
                    }),
                },
                _a),
            // @ts-ignore
            stepsToClearOnSubmitFromSummary: function (currentStepIndex) { return [
                currentStepIndex + 1,
            ]; },
        };
    };
};
export var uiSchema = function (extraData) {
    var _a;
    var _b;
    return (_a = {
            "rentio:title": getLocalizedText("payments.create.payee.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData),
            "rentio:summaryTitle": getLocalizedText("payments.create.payee.heading.summary")
        },
        _a[EField.Header5] = {
            "ui:field": ERentioFormField.SectionHeader,
            // A cost or settlement payment: the beneficiary is whoever gets the
            // tenant's money (the owner or the office), never the supplier.
            getTitle: function (formData) {
                var _a;
                return ((_a = extraData.prefill) === null || _a === void 0 ? void 0 : _a.costPayment)
                    ? getLocalizedText("payments.create.payee.heading.cost_reimbursement")
                    : getLocalizedText("payments.create.payee.heading", {
                        type: formData.otherDescription ||
                            getLocalizedText("payment.payment_order.type.".concat(formData.typeRecurring || formData.typeOnce).toLowerCase()),
                    });
            },
        },
        _a[EField.Payee] = {
            "ui:field": ERentioFormField.ContactSelectInlineV2,
            // The cost flow's heading already asks the question.
            getTitle: function () {
                var _a;
                return getLocalizedText(((_a = extraData.prefill) === null || _a === void 0 ? void 0 : _a.costPayment)
                    ? "payment.payment_order.payee"
                    : "payment.payment_order.payee.heading");
            },
            info: ((_b = extraData.prefill) === null || _b === void 0 ? void 0 : _b.costPayment)
                ? getLocalizedText("payments.create.payee.cost_reimbursement.info")
                : undefined,
            selectContactFromListCtaTitle: getLocalizedText("payment.payment_order.payee.select_other.cta"),
            addCtaLabel: getLocalizedText("payment.payment_order.payee.other.label"),
            isMultiSelect: false,
            asOptionList: true,
            // Custom selectors & actions
            valueSelector: function (state, selectedAccountIds) {
                return customContactsValueSelector({
                    state: state,
                    propertyId: extraData.property.id,
                    selectedAccountIds: selectedAccountIds,
                });
            },
            customGetSubtitleSelector: function (state, formData, item) {
                return getSubtitle({
                    state: state,
                    contract: getRelatedContract(extraData, formData),
                    propertyId: extraData.property.id,
                    item: item,
                });
            },
            customExtraAccountsSelector: function (state, formData) {
                var _a;
                if (formData === void 0) { formData = {}; }
                return customContactsSelector({
                    formData: formData,
                    type: formData[EField.TypeRecurring] || formData[EField.TypeOnce],
                    payerType: "payee",
                    state: state,
                    contract: getRelatedContract(extraData, formData),
                    costPayment: !!((_a = extraData.prefill) === null || _a === void 0 ? void 0 : _a.costPayment),
                    propertyId: extraData.property.id,
                });
            },
            customIsFetchingSelector: function (state) {
                return customIsFetchingSelector(state, extraData);
            },
            customGetContactsActions: customGetContactsActions(extraData),
        },
        _a);
};
